import {
  Component,
  effect,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AddPricingPartnerBundleAction } from '@app/modules/pricing/store/pricing-partner.actions';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-edit-price-dialog',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './edit-price-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './edit-price-dialog.component.scss',
})
export class EditPriceDialogComponent {
  public partnerId = signal<string>(null);
  public bundleId = signal<string>(null);
  public price = signal<number>(null);

  protected modalRef = inject(NgbActiveModal);
  private store = inject(Store);

  protected priceFormControl = new FormControl<number>(null);

  constructor() {
    effect(() => {
      this.priceFormControl.setValue(this.price());
    });
  }

  protected updatePrice() {
    this.store.dispatch(
      new AddPricingPartnerBundleAction(
        this.partnerId(),
        this.bundleId(),
        this.priceFormControl.value,
        null
      )
    );

    this.modalRef.close();
  }
}
